import React from 'react'
import { initializeApollo } from '@gql/client'
import {
  BrandsDocument,
  EffettiDocument,
  MagazineEvidenzaDocument,
  MagazineHomepageDocument,
  PaginaDocument,
  ProgettiDocument,
  ProgettiEvidenzaDocument,
  SoluzioniDocument,
  UltimeCollezioniDocument,
  useCollezioniQuery,
} from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import HomeTemplate from '@components/templates/HomeTemplate/HomeTemplate'

const HomePage = ({ pagina, soluzioni, collezioni, progetti, magazine, brands, effetti }) => {
  return (
    <HomeTemplate
      pagina={pagina}
      soluzioni={soluzioni}
      collezioni={collezioni}
      progetti={progetti}
      magazine={magazine}
      brands={brands}
      effetti={effetti}
    />
  )
}

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'homepage', preview },
      context: {
        headers,
      },
    })

    const {
      data: { soluzioni },
    } = await client.query({
      query: SoluzioniDocument,
      context: {
        headers,
      },
    })

    const {
      data: { brands },
    } = await client.query({
      query: BrandsDocument,
      context: {
        headers,
      },
    })

    const {
      data: { ultimeCollezioni },
    } = await client.query({
      query: UltimeCollezioniDocument,
      context: {
        headers,
      },
    })

    const {
      data: { progettiEvidenza },
    } = await client.query({
      query: ProgettiEvidenzaDocument,
      context: {
        headers,
      },
    })

    const {
      data: { magazineHomepage },
    } = await client.query({
      query: MagazineHomepageDocument,
      context: {
        headers,
      },
    })

    const {
      data: { effetti },
    } = await client.query({
      query: EffettiDocument,
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }
    return {
      props: {
        pagina,
        soluzioni,
        brands,
        collezioni: ultimeCollezioni,
        progetti: progettiEvidenza,
        magazine: magazineHomepage,
        effetti,
      },
      revalidate: 60 * 60 * 24,
    }
  },
  '/'
)

export default HomePage
